<script>
export default {
 name: 'Tabs',

 data() {
   return {
     showTab: true
   }
 }
}
</script>

<template>

</template>



// WEBPACK FOOTER //
// _js/components/Tabs.vue